import React,{useState,useContext,useEffect} from 'react'
import { ManagerAuthConsultant } from "../context/AuhConsultant";

export const DasheboardCons = () => {

    const { currentUserCons } = useContext(ManagerAuthConsultant);

 if (currentUserCons.tel === null) {
    } else {
        
  return (
    <>
    <section class="m-0 content" dir='rtl'>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-xl-3">
                    <div class="data-box-container d-flex align-items-center b-24">
                        <a href="#" class="data-box-icon">
                            <img src="../icons/Ticket-primary.svg" alt="" />
                        </a>
                        <div class="d-flex flex-column">
                            <h3 class="h6">تیکت های شما</h3>
                            <span><a href="#">4</a>تیکت خوانده نشده دارید</span>
                        </div>
                        <a href="#" class="data-box-more">
                            <img src="../icons/arrow-left.svg" alt="" />
                        </a>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-xl-3">
                    <div class="data-box-container d-flex align-items-center b-24">
                        <a href="#" class="data-box-icon">
                            <img src="../icons/flash-primary.svg" alt="" />
                        </a>
                        <div class="d-flex flex-column">
                            <h3 class="h6">سیر بیماری</h3>
                            <span><a href="#">1402/03/03</a>آخرین ارسالی</span>
                        </div>
                        <a href="#" class="data-box-more">
                            <img src="../icons/arrow-left.svg" alt="" />
                        </a>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-xl-3">
                    <div class="data-box-container d-flex align-items-center b-24">
                        <a href="#" class="data-box-icon">
                            <img src="../icons/Ticket-primary.svg" alt="" />
                        </a>
                        <div class="d-flex flex-column">
                            <h3 class="h6">تیکت های شما</h3>
                            <span><a href="#">4</a>تیکت خوانده نشده دارید</span>
                        </div>
                        <a href="#" class="data-box-more">
                            <img src="../icons/arrow-left.svg" alt="" />
                        </a>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-xl-3">
                    <div class="data-box-container d-flex align-items-center b-24">
                        <a href="#" class="data-box-icon">
                            <img src="../icons/Ticket-primary.svg" alt="" />
                        </a>
                        <div class="d-flex flex-column">
                            <h3 class="h6">تیکت های شما</h3>
                            <span><a href="#">4</a>تیکت خوانده نشده دارید</span>
                        </div>
                        <a href="#" class="data-box-more">
                            <img src="../icons/arrow-left.svg" alt="" />
                        </a>
                    </div>
                </div>
                <h1 class="page-title text-secondary text-start w-100 t-40">آخرین معالجات ارسال شده</h1>
                <div class="table-responsive">
                    <table class="table bg-white custom-rounded t-24">
                        <thead>
                            <tr class="text-center">
                                <th><span>کاربر</span></th>
                                <th><span>تعداد معالجات</span></th>
                                <th><span>مشاور</span></th>
                                <th><span>در تاریخ</span></th>
                                <th><span>امضا پزشک</span></th>
                                <th><span>عملیات</span></th>
                            </tr>
                        </thead>
                        <tbody class="text-center">
                            <tr>
                                <td class="fw-bold">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <img src="../img/Avatar-Image.png" class="rounded-circle" width="50"
                                            alt="" />
                                        <div
                                            class="d-flex flex-column justify-content-start align-items-start mr-16 text-right">
                                            <p class="mb-0">میلاد اعرابها</p>
                                            <p class="mb-0 auth-number text-default fw-normal">989130537010</p>
                                        </div>
                                    </div>
                                </td>
                                <td>69</td>
                                <td>
                                    <span class="tag">احمدی روشن</span>
                                </td>
                                <td>1402/03/03</td>
                                <td><span class="tags">تایید شده</span></td>
                                <td> <button type="button" class="action-tag" data-toggle="modal"
                                        data-target="#Removemodal">
                                        حذف
                                    </button></td>
                        
                                <div class="modal fade" id="Removemodal" tabindex="-1" role="dialog"
                                    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header text-center border-0 p-0">
                                                <img src="../img/remove.png" class="m-auto" alt="" />
                                            </div>
                                            <div class="modal-body text-center border-0 p-0 border-end-0">
                                                <h3>مطمعنی میخوای حذف کنی</h3>
                                                <p class="t-16">شما درحال حذف کاربر میلاد اعرابها هستید . آیا حذف انجام
                                                    شود؟</p>
                                            </div>
                                            <div
                                                class="modal-footer flex-row-reverse border-0 w-100 justify-content-center p-0">
                                                <button type="button" class="btn custom-btn-secondary d-inline-block"
                                                    data-dismiss="modal">لغو</button>
                                                <button type="button" class="btn custom-btn-danger d-inline-block">بله
                                                    حذف کن</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    </>
  )
}
}
